/**
 * Which half of the transfer flow is on screen, if any.
 *
 * A store rather than local state because the buttons that open it are
 * `"action"` settings items (settings/pages/ai.ts) — plain data with an
 * `onClick`, no access to React state — while the dialog itself is rendered by
 * SettingsDialog.tsx.
 */

import { create } from "zustand";

export type TransferMode = "show" | "scan";

interface TransferDialogState {
  mode: TransferMode | null;
  open: (mode: TransferMode) => void;
  close: () => void;
}

export const useTransferDialogStore = create<TransferDialogState>((set) => ({
  mode: null,
  open: (mode) => set({ mode }),
  close: () => set({ mode: null }),
}));
